import React from 'react';
import SectionLayout from 'atoms/Layout/Section/SectionLayout';
import BusinessRevenueCalculator from 'organisms/Homepage/BusinessRevenueCalculator/BusinessRevenueCalculator';

const Calculator = (): JSX.Element => {
  return (
    <SectionLayout
      maxWidth='width-3xl'
      padding={['spacing-7xl', 'spacing-4xl']}
      paddingSm={['spacing-4xl', 'spacing-xl']}
      background='bg-tertiary'
      data-track-section='revenue-calculator'
    >
      <BusinessRevenueCalculator />
    </SectionLayout>
  );
};

export default Calculator;
